/* tslint:disable */
/* eslint-disable */
/**
 * Ameta Availability API
 * A rest api for managing the ameta availability system
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SectionCounterDataSections
 */
export interface SectionCounterDataSections {
    /**
     * 
     * @type {string}
     * @memberof SectionCounterDataSections
     */
    minutesClosedDay: string;
    /**
     * 
     * @type {string}
     * @memberof SectionCounterDataSections
     */
    minutesClosedNight: string;
    /**
     * 
     * @type {string}
     * @memberof SectionCounterDataSections
     */
    totalMinutes: string;
    /**
     * 
     * @type {string}
     * @memberof SectionCounterDataSections
     */
    availability: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SectionCounterDataSections
     */
    eventTimes: { [key: string]: string; };
}

export function SectionCounterDataSectionsFromJSON(json: any): SectionCounterDataSections {
    return SectionCounterDataSectionsFromJSONTyped(json, false);
}

export function SectionCounterDataSectionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionCounterDataSections {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'minutesClosedDay': json['minutesClosedDay'],
        'minutesClosedNight': json['minutesClosedNight'],
        'totalMinutes': json['totalMinutes'],
        'availability': json['availability'],
        'eventTimes': json['eventTimes'],
    };
}

export function SectionCounterDataSectionsToJSON(value?: SectionCounterDataSections | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'minutesClosedDay': value.minutesClosedDay,
        'minutesClosedNight': value.minutesClosedNight,
        'totalMinutes': value.totalMinutes,
        'availability': value.availability,
        'eventTimes': value.eventTimes,
    };
}


